/**
 * Copyright (c) Mayoral Moda Infantil, S.A.U. and affiliates.
 */

import { TFunction } from 'next-i18next';

import { Season } from '@/types/global';

/**
 * Given a season identifier, returns the season name and year in the current language.
 * E.g. for season 'V21', returns 'Summer 21'.
 */
export const seasonToLabel = (season: string, t: TFunction) => {
  const seasonKey = season.substring(0, 1);
  const year = season.substring(1);

  let label = t('VERANO');
  if (seasonKey === 'I') {
    label = t('INVIERNO');
  }

  return `${label} ${year}`;
};

/**
 * Finds the first available season
 */
export const firstFirstAvailableSeason = (seasons: Season[]): Season => {
  if (seasons.length === 0) {
    return null;
  }
  return seasons[0];
};
